module.exports = __webpack_public_path__ + "img/room-popularity-award_zhar.0e532a1d.png";